module.exports = __webpack_public_path__ + "static/media/15.96bcc5a5.png";